export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/icon_modify_normal@2x.png";